<template>
<div class="chapter">
<div class="inner_page">
<p class="nonindent" id="fm3"><br/><br/></p>
<p class="hanging1">sabotage… <em>n</em>. [Fr. &lt; <em>sabot</em>, wooden shoe + −<span class="small">AGE:</span> from damage done to machinery by sabots]….</p>
<p class="right">—<em>Webster’s New World Dictionary</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795317361_epub_fm3_r1.vue?274814f9